import { TransitionConditionPlugin } from '../TransitionConditionPlugin';
import { CheckDependenciesPlugin } from './CheckDependenciesPlugin';
import { CreateNewFileVersionConfigPlugin } from './CreateNewFileVersionConfigPlugin';
import { CheckSubTasksPlugin } from './CheckSubTasksPlugin';
import { CheckTeamPlugin } from './CheckTeamPlugin';
import { ConfirmPlugin } from './ConfirmPlugin';
// import { DataConditionPlugin } from './DataConditionPlugin';
import { RequiredFieldsPlugin } from './RequiredFieldsPlugin';
import { SignaturePlugin } from './SignaturePlugin';

/**
 * Register transition condition plugins in this array
 */
const transitionConditionPlugins: TransitionConditionPlugin<any>[] = [
  RequiredFieldsPlugin,
  ConfirmPlugin,
  SignaturePlugin,
  CheckSubTasksPlugin,
  CheckTeamPlugin,
  CheckDependenciesPlugin,
  CreateNewFileVersionConfigPlugin
  // DataConditionPlugin
];

export default transitionConditionPlugins;
